<template>
	<div class="list-container">
		<ListItem v-for="(item, index) in items" :key="index" :bullet="item.bullet">
			{{ t(item.text) }}
		</ListItem>
	</div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import ListItem from './ListItem.vue'

export default {
	name: 'ListMain',
	props: {
		items: {
			type: Array,
			required: true,
			default: () => []
		}
	},
	components: { ListItem },
	setup() {
		const { t } = useI18n()

		return {
			t
		}
	}
}
</script>

<style lang="scss" scoped>
.list-container {
	margin: 30px 0px;

	:not(:last-of-type) {
		margin-bottom: 14px;
	}
}
</style>
>
